<template>
<div class="chapter">
<div class="inner_page">
<p class="figc"><img alt="" src="images/pg5_2.jpg"/></p>
<p class="ack-title">ACKNOWLEDGMENTS</p>
<p class="ded">To all my students, you have been my best teachers!</p>
<p class="ded">To “Strings,” my minigroup, for all the support and love you’ve given me throughout the years; Susanne M. Rasmussen, for your expedience and excellent machine quilting; Joyce Lytle and Lee Jonsson, for helping me make my dream a reality; Jennifer Sampou, for your inspirational designs; and C&amp;T Publishing, for believing in me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_acknowledgement.vue?7c22a43b